/*
 * Copyright (c) 2020. Dave van Rijn Development
 */

import './style/loginView.scss';

import React, {FocusEventHandler, KeyboardEventHandler, MouseEventHandler, useContext} from 'react';
import classNames from 'classnames';
import {
    ChangeKeyFunction, colorIsWhite, convertColor, DvrdButton, DvrdInput, DVRDPasswordInput, ErrorType, Loader,
    preventDefault
} from '@dvrd/dvr-controls'
import {AppContext} from "../../context/appContext";

interface Props {
    onSubmit: MouseEventHandler & KeyboardEventHandler;
    onChange: ChangeKeyFunction<string>;
    onFocusField: FocusEventHandler;
    email: string;
    password: string;
    loading: boolean;
    error: ErrorType;
}

export default function LoginView(props: Props) {
    const context = useContext(AppContext);
    const {loading, error, onFocusField, onSubmit, email, password, onChange} = props;

    function getBaseColor(): string {
        const {baseColor, contrastColor} = context.theme;
        let color = convertColor(baseColor);
        if (colorIsWhite(color)) color = convertColor(contrastColor);
        return color;
    }

    function renderHeader() {
        return (
            <div className='header-container'>
                <label className='header-title' style={{color: getBaseColor()}}>Inloggen</label>
            </div>
        )
    }

    function renderBody() {
        return (
            <form className='body-container' onSubmit={preventDefault}>
                <DvrdInput onChange={onChange('email')} value={email}
                           inputProps={{type: 'email', autoComplete: 'username'}} label='E-mailadres'
                           onFocus={onFocusField} onEnter={onSubmit}/>
                <DVRDPasswordInput onChange={onChange('password')} value={password} label='Wachtwoord'
                                   onFocus={onFocusField} onEnter={onSubmit}
                                   inputProps={{autoComplete: 'current-password'}}/>
                <label className={classNames('error-label', error !== null && 'visible')}>{error}</label>
            </form>
        )
    }

    function renderFooter() {
        return (
            <div className='footer-container'>
                <DvrdButton label='Inloggen' onClick={onSubmit} disabled={loading}/>
            </div>
        );
    }

    return (
        <div className='login-view'>
            <Loader active={loading}/>
            {renderHeader()}
            {renderBody()}
            {renderFooter()}
        </div>
    )
}